<div *ngIf="mappedChartDatasetsReady">

    <div #canvasContainer class="canvas-container">

        <canvas baseChart
                *ngIf="chartOptionsReady"
                [datasets]="mappedChartDatasets"
                [labels]="mappedChartAxisLabels"
                [legend]="chartLegend"
                [options]="chartOptions"
                [type]="chartType">
        </canvas>
    </div>

    <div *ngIf="mappedTableValuesReady && tableDataAvailable">

        <p-dialog [header]="tableTitle"
                  [modal]="true"
                  [(visible)]="tableDialogOpen"
                  [style]="{ height: '90%', width: '90%' }">

            <table>
                <thead>
                <tr>

                    <th class="group">{{ tableGroupColumnLabel }}</th>

                    <ng-container *ngIf="multipleDataPoints">
                        <ng-container *ngFor="let dataPoint of array(chartData); let i = index">

                            <th class="count">
                                {{ dataPoint.tableColumnLabel || ('Dataset ' + i) }}
                            </th>

                        </ng-container>
                    </ng-container>

                    <th class="min">Min</th>
                    <th class="avg">Avg</th>
                    <th class="max">Max</th>

                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let entry of mappedTableValues">
                    <tr>

                        <td class="group">{{ entry.group }}</td>

                        <ng-container *ngIf="multipleDataPoints">
                            <ng-container *ngFor="let _ of array(chartData); let i = index">

                                <td class="count">
                                    <ng-container *ngIf="entry.individual && entry.individual[i]">
                                        min: {{ entry.individual[i].min }} /
                                        avg: {{ entry.individual[i].avg }} /
                                        max: {{ entry.individual[i].max }}
                                    </ng-container>
                                </td>

                            </ng-container>
                        </ng-container>

                        <td class="min">{{ entry.min }}</td>
                        <td class="avg">{{ entry.avg }}</td>
                        <td class="max">{{ entry.max }}</td>

                    </tr>
                </ng-container>
                </tbody>
            </table>

        </p-dialog>

        <p-contextmenu [model]="canvasContextMenuItems"
                       [target]="canvasContainer"
                       [appendTo]="'body'"></p-contextmenu>
    </div>
</div>
